﻿import { Command, IframeView, InputTextView } from 'ckeditor5';

class OpenBasicLinkPopupCommand extends Command {
    refresh() {
        const model = this.editor.model;
        this.isEnabled = model.schema.checkAttributeInSelection(model.document.selection, 'linkHref');
        this.value = getSelectedLink(this.editor);
    }

    execute() {
        const editor = this.editor;
        const { t } = editor.locale;
        const dialog = editor.plugins.get('Dialog');

        function blockBlur(eventInfo) {
            eventInfo.stop();
        }

        // block/stop blur event to avoid closing campaign editor when switching tabs in placeholder chooser
        editor.on('blur', blockBlur, { priority: 'highest' });

        // "dummy" textbox to set focus to (to avoid focus on close button)
        let focusElement = new InputTextView();
        focusElement.set({ tabIndex: -1, withText: false, id: 'hidden-focus-element' });

        function close() {
            dialog.hide();
            editor.editing.view.focus();
        }

        function saveLink(evt) {
            editor.execute('link', evt.detail.url);
            close();
        }

        window.addEventListener('BasicLinkPopup_Save', saveLink);
        window.addEventListener('BasicLinkPopup_Close', close);

        dialog.show({
            isModal: true,
            title: t('Link'),
            content: [
                focusElement,
                _buildFrameView(editor, this.value)
            ],
            className: 'placeholder-chooser-dialog',
            onHide() {
                // unregister events when closing the dialog
                editor.off('blur', blockBlur);
                window.removeEventListener('BasicLinkPopup_Save', saveLink);
                window.removeEventListener('BasicLinkPopup_Close', close);
            }
        });
    }
}

function _buildFrameView(editor, selectedLink) {
    const frameView = new IframeView(editor.locale);
    const { t } = editor.locale;

    var iframePath = new URL("/Dynamix/App", location.href);
    iframePath.hash = "#/Controls/BasicLink?";
    if (selectedLink) {
        let params = new URLSearchParams();
        params.set('link', selectedLink.url);
        iframePath.hash += params.toString();
    }

    frameView.set({
        label: t('Link'),
        tooltip: true,
        withText: false
    });

    frameView.extendTemplate({
        attributes: {
            style: {
                width: '600px',
                height: '530px',
                margin: '20px 25px',
            },
            src: iframePath.toString()
        },
    });

    delete frameView.template.attributes.sandbox;

    return frameView;
}

function getSelectedLink(editor) {
    try {
        var range = editor.model.document.selection.getFirstRange();
        for (var value of range.getWalker()) {
            if (value.type === 'text' && value.item.hasAttribute('linkHref')) {
                return { url: value.item.getAttribute('linkHref'), text: value.item.data };
            }
            else if (value.item && value.item.name === 'imageInline' && value.item.hasAttribute('linkHref')) {
                return { url: value.item.getAttribute('linkHref'), text: '' };
            }
        }

        var position = editor.model.document.selection.getFirstPosition();
        if (position && position.textNode && position.textNode.hasAttribute('linkHref')) {
            return { url: position.textNode.getAttribute('linkHref'), text: position.textNode.data };
        }

        return null;
    }
    catch (e) {
        return null;
    }
}

export default OpenBasicLinkPopupCommand;